import(/* webpackMode: "eager", webpackExports: ["ReviewView"] */ "/vercel/path0/ui/components/app/ReviewView.tsx");
